import { create } from 'zustand';

interface User {
  id: number;
  username: string;
  email: string;
  name: string;
  phone: string;
  status: string;
  is_admin: boolean;
}

interface AuthStore {
  user: User | null;
  token: string | null;
  isAdmin: boolean;
  isLoggedIn: boolean;
  setAuth: (user: User, token: string) => void;
  logout: () => void;
  init: () => void;
}

export const useAuthStore = create<AuthStore>((set) => ({
  user: null,
  token: null,
  isAdmin: false,
  isLoggedIn: false,

  setAuth: (user, token) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    set({ user, token, isAdmin: user.is_admin, isLoggedIn: true });
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    set({ user: null, token: null, isAdmin: false, isLoggedIn: false });
  },

  init: () => {
    const token = localStorage.getItem('token');
    const userStr = localStorage.getItem('user');
    if (token && userStr) {
      try {
        const user = JSON.parse(userStr);
        set({ user, token, isAdmin: user.is_admin, isLoggedIn: true });
      } catch (e) {}
    }
  },
}));

interface ExamStore {
  examType: '필기' | '실기';
  selectedSubject: string;
  currentMode: 'normal' | 'mock' | 'wrong';
  setExamType: (type: '필기' | '실기') => void;
  setSelectedSubject: (subject: string) => void;
  setCurrentMode: (mode: 'normal' | 'mock' | 'wrong') => void;
}

export const useExamStore = create<ExamStore>((set) => ({
  examType: '필기',
  selectedSubject: '',
  currentMode: 'normal',
  setExamType: (examType) => set({ examType }),
  setSelectedSubject: (selectedSubject) => set({ selectedSubject }),
  setCurrentMode: (currentMode) => set({ currentMode }),
}));
